import { Component, Input, Output, EventEmitter, OnInit, ViewChild, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs/Observable';
import { MCRFolderElement } from 'src/app/_models/mcrfolderelement';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SelectionModel } from '@angular/cdk/collections';
import { DocumentService } from 'src/app/_services/document.services';

@Component({
  selector: 'app-fileexplorer',
  templateUrl: './fileexplorer.component.html',
  styleUrls: ['./fileexplorer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FileexplorerComponent  implements OnInit{

  constructor(
    private matIconRegistry:MatIconRegistry,
    private domSanitzer:DomSanitizer,
    private documentService: DocumentService
  ) {
    this.matIconRegistry.addSvgIcon(
      'pdf',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/pdf.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'jpeg',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/jpg.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'ppt',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/ppt.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xls',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/xls.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'txt',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/txt.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'doc',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/doc.svg')
    );
  }

  @Input() folderElements: MCRFolderElement[];
  @Input() canNavigateUp: string;
  @Input() path: string;
  @Input() level: string;
  @Input() selectedLocation: string;
  filterValue: String;
  filterElements: MCRFolderElement[];
  pagedList: MCRFolderElement[]; 
  breakpoint: number = 10;
  length: number;
  selection = new SelectionModel<any>(true, []);

  
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Output() folderAdded = new EventEmitter<{ name: string }>();
  @Output() elementRemoved = new EventEmitter<MCRFolderElement>();
  @Output() navigatedDown = new EventEmitter<MCRFolderElement>();
  @Output() displayFile = new EventEmitter<MCRFolderElement>();
  @Output() navigatedUp = new EventEmitter();

  ngOnInit() {
    this.breakpoint = (window.innerWidth <= 800) ? 5 : 10;
    //console.log("elements "+JSON.stringify(this.folderElements));
    console.log(this.breakpoint);
    this.pagedList = this.folderElements.slice(0, 50);
    this.length = this.folderElements.length;
    
  }

  OnPageChange(event: PageEvent){
    let startIndex = event.pageIndex * event.pageSize;
    let endIndex = startIndex + event.pageSize;
    if(endIndex > this.length){
      endIndex = this.length;
    }
    this.pagedList = this.folderElements.slice(startIndex, endIndex);
  }

  onResize(event) { //to adjust to screen size
    this.breakpoint = (event.target.innerWidth <= 800) ? 5 : 10;
  }

  ngOnChanges(changes: SimpleChanges) {
    //console.log(this.selectedDocument)
    //console.log("elements "+JSON.stringify(this.folderElements));
    this.breakpoint = (window.innerWidth <= 800) ? 5 : 10;
    this.pagedList = this.folderElements.slice(0, 50);
    this.length = this.folderElements.length;
  }

  deleteElement(element: MCRFolderElement) {
    this.elementRemoved.emit(element);
  }

  navigate(element: MCRFolderElement) {
    if (element.isFolder) {
      this.navigatedDown.emit(element);
    } else {
      this.selection = new SelectionModel<any>(true, []);
      this.displayFile.emit(element);
    }
  }

  navigateUp() {
    this.selection.clear;
    this.navigatedUp.emit();
  }

  applyFilterOnFolders(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value;
    //let count = 0
    //console.log(this.filterValue)
    if (this.filterValue.length > 0) {
      this.filterElements = []
      this.search()
    } else {
      this.pagedList = this.folderElements;
      this.pagedList = this.folderElements.slice(0, 50);
      this.length = this.folderElements.length;
    }
   
  }

  search() {
    this.pagedList.filter(folder => {
      if ((folder.name.trim().toLowerCase().indexOf(this.filterValue.trim().toLowerCase()) > -1)) {
        this.filterElements.push(folder)
      }
     
      this.filterElements = this.filterElements.filter((elem, i, arr) => {
        if (arr.indexOf(elem) === i) {
          return elem
        }
      })
    }
    )

    this.pagedList = this.filterElements;
    this.pagedList = this.filterElements.slice(0, 50);
    this.length = this.filterElements.length;
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.pagedList.length;
    //console.log("Selected", this.selection.selected)
    return numSelected === numRows;
  }

  masterToggle(ref) {
    //console.log(this.selection.selected)
    if (this.isSomeSelected()) {
      
      this.selection.clear();
    ref.checked=false;
      
    } else {
      this.isAllSelected() ?
        this.selection.clear() :
        this.selecteAll();
    }
    // console.log(ref);
  }

  isSomeSelected() {
    //console.log(this.selection.selected.length);
    return this.selection.selected.length > 0;
  }

  selecteAll() {
   
      this.pagedList.forEach(row => this.selection.select(row.documentId));
    
  }

  exportDocuments() {
    console.log("DocumentIDs",this.selection.selected.join());
    var request = {
      "docid" : this.selection.selected.join().split(",")
    }
    this.selection.clear();
    this.documentService.exportDocuments(request).subscribe(
      response => { 
        console.log("Response "+response);
      });

   }

  
}
